import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Login from '../components/Login'
import { isAuthenticated } from '../services/authService'
import { getStoredApiKey } from '../services/apiKeyService'

function LoginPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const apiKey = getStoredApiKey()
    const authenticated = apiKey || isAuthenticated()
    
    if (authenticated) {
      navigate('/', { replace: true })
    }
  }, [navigate])

  const handleLoginSuccess = () => {
    navigate('/', { replace: true })
  }

  return <Login onLoginSuccess={handleLoginSuccess} />
}

export default LoginPage

